import _ from 'lodash';
import { Component, OnInit, Input, OnChanges, SimpleChanges, inject, DestroyRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { first } from 'rxjs/operators';
import { selectVirtualEventData } from 'app/virtual-event/features/data/data.selectors';
import { declareVirtualEventLastHero } from '../../features/last-hero/last-hero.actions';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-currently-live-last-hero',
  templateUrl: './currently-live-last-hero.component.html',
  styleUrls: ['./currently-live-last-hero.component.scss']
})
export class CurrentlyLiveLastHeroComponent implements OnInit, OnChanges {
  destroyRef = inject(DestroyRef)
  @Input() campaign: any = null;
  @Input() option: any = null;
  @Input() list: any[] = [];

  public status: any = null;
  public buttonLabel: string = null;
  public winner: any = null;

  constructor(
    private store: Store
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    const campaign = _.get(changes, 'campaign.currentValue', this.campaign);
    const option = _.get(changes, 'option.currentValue', this.option);
    const list = _.get(changes, 'list.currentValue', this.list);

    const result = _.find(list, { id: campaign.id });
    this.status = _.get(result, 'campaignTypeData.status', 0);
    this.buttonLabel = this.status > 0 ? 'Declared': 'Declare Last Hero';
    this.winner = _.get(result, 'campaignTypeData.winnerUser', null);
  }

  getImageUrl() {
    const { option } = this;
    return option.imageUrl === '' ? '/images/blank-image.png': option.imageUrl;
  }

  declareLastHero() {
    const { campaign } = this;
    this.store.pipe(
      select(selectVirtualEventData),
      first(),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(({ id: vEventId }: any) => {
      this.store.dispatch({
        type: declareVirtualEventLastHero.type,
        payload: { vEventId, campaign }
      });
    });
  }

}
